export default __webpack_public_path__ + "static/media/user.691eb517.svg";